<template>
    <div class="column_center_center w-screen h-screen bg-black bg-opacity-70 fixed top-0 left-0 right-0 bottom-0"
        v-if="show">
        <div class="column_center_start container pt-8">
            <div class="column_center_start w-full">
                <text class="text-xl font-semibold">即將取消此訂單</text>
            </div>
            <div class="row_center_between w-full mt-8">
                <button @click="close" class="cancel_button">維持訂單</button>
                <button @click="confirm" class="confirm_button">取消訂單</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            show: false,
            orderItem: {}
        }
    },
    methods: {
        close() {
            this.show = false
        },
        confirm() {
            this.show = false
            this.$emit('confirm', this.orderItem)
        },
        showDialog(orderItem) {
            this.show = true
            this.orderItem = orderItem
        }
    }
}
</script>
<style lang="scss" scoped>
.container {
    width: 94vw;
    background-color: #fff;
    border-radius: 8px;
}

button {
    width: 49.6%;
    height: 56px;
    border: none;
    font-size: 20px;
    font-weight: 500;
    font-family: PingFang SC;
    color: #000;
}

.cancel_button {
    border-radius: 0 0 0 8px;
    background-color: #EEEEEE;
}

.confirm_button {
    border-radius: 0 0 8px 0;
    background-color: #FBCB02;
}
</style>
